import React from 'react';
import MonthByMonthPhaseLoader, {monthByMonthPhaseLoaderQuery} from './MonthByMonthPhaseLoader';
import MonthByMonthRoleLoader, {monthByMonthRoleLoaderQuery} from './MonthByMonthRoleLoader';
import {getPhaseName, getRoleName} from '../ProjectPortfolioReportUtils';
import {PHASE_BREAKDOWN_TYPE} from '../../../../constants';
import {LoadMore} from '../../../loaders/LoadMore';
import {Table} from '@/web-components';
import ProjectPortfolioMonthByMonthRow from './ProjectPortfolioMonthByMonthRow';

const MonthByMonthPhaseRoleCascade = ({
	intl,
	projectId,
	deliverableId,
	startDate,
	endDate,
	timeSearchQuery,
	expenseSearchQuery,
	selectedSingleValue,
	useWinProbability,
	fixedPriceLocks,
	levelProps,
	withProject,
}) => {
	return (
		<LoadMore
			key="query-render-month-by-month-phase"
			query={monthByMonthPhaseLoaderQuery}
			loader={<MonthByMonthPhaseLoader />}
			variables={{
				projectId,
				deliverableId,
				timeSearchQuery: timeSearchQuery,
				expenseSearchQuery: expenseSearchQuery,
				startYear: startDate.year(),
				startMonth: startDate.month() + 1,
				startDay: startDate.date(),
				endYear: endDate.year(),
				endMonth: endDate.month() + 1,
				endDay: endDate.date(),
				selectedSingleValue: selectedSingleValue,
				ignoreBaselineWinChance: !useWinProbability,
				excludeOpportunityActuals: true,
			}}
		>
			{({data: phaseBreakdownData}) => {
				return (
					<Table.Rows data={phaseBreakdownData} {...levelProps} canExpand={true}>
						{({
							rowData: phaseRowData,
							tableColumnsProps: phaseTableColumnProps,
							expanded: phaseExpanded,
							nextLevelProps: roleLevelProps,
						}) => {
							return (
								<>
									<ProjectPortfolioMonthByMonthRow
										rowData={withProject(phaseRowData)}
										tableColumnProps={phaseTableColumnProps}
										headerColumn={getPhaseName(intl, phaseRowData)}
										canExpand={
											phaseRowData.breakdownType === PHASE_BREAKDOWN_TYPE.PHASE ||
											phaseRowData.breakdownType === PHASE_BREAKDOWN_TYPE.NO_PHASE
										}
										selectedSingleValue={selectedSingleValue}
										fixedPriceLocks={fixedPriceLocks}
										useWinProbability={useWinProbability}
									/>
									{phaseExpanded && (
										<LoadMore
											key="query-render-month-by-month-role"
											query={monthByMonthRoleLoaderQuery}
											loader={<MonthByMonthRoleLoader />}
											variables={{
												timeSearchQuery: timeSearchQuery,
												expenseSearchQuery: expenseSearchQuery,
												projectId,
												deliverableId,
												phaseId:
													phaseRowData.breakdownType === PHASE_BREAKDOWN_TYPE.PHASE
														? phaseRowData.phase.id
														: phaseRowData.breakdownType === PHASE_BREAKDOWN_TYPE.NO_PHASE
														? 0
														: null,
												startYear: startDate.year(),
												startMonth: startDate.month() + 1,
												startDay: startDate.date(),
												endYear: endDate.year(),
												endMonth: endDate.month() + 1,
												endDay: endDate.date(),
												selectedSingleValue: selectedSingleValue,
											}}
										>
											{({data: roleBreakdownData}) => {
												return (
													<Table.Rows data={roleBreakdownData} {...roleLevelProps} canExpand={false}>
														{({rowData: roleRowData, tableColumnsProps: roleTableColumnProps}) => {
															return (
																<ProjectPortfolioMonthByMonthRow
																	rowData={withProject(roleRowData)}
																	tableColumnProps={roleTableColumnProps}
																	headerColumn={getRoleName(intl, roleRowData)}
																	selectedSingleValue={selectedSingleValue}
																	fixedPriceLocks={fixedPriceLocks}
																	useWinProbability={useWinProbability}
																/>
															);
														}}
													</Table.Rows>
												);
											}}
										</LoadMore>
									)}
								</>
							);
						}}
					</Table.Rows>
				);
			}}
		</LoadMore>
	);
};

export default MonthByMonthPhaseRoleCascade;
